const faqData = [
  {
    question: "오산 센트럴시티 운암뜰은 어디에 들어서나요?",
    answer: `
오산 센트럴시티 운암뜰은 경기도 오산시 부산동 614번지 일원에 공급되는 10년 장기 민간임대 브랜드 아파트입니다.<br/><br/>

사업지는 오산 운암뜰 AI시티 개발권역과 인접한 핵심 입지에 위치하며 오산 신흥 주거벨트의 미래가치를 함께 기대할 수 있는 주거단지입니다.<br/><br/>

오산IC와 오산역, 동탄신도시 생활권 접근성이 우수하며 운암뜰 도시개발사업의 수혜가 기대되는 지역으로 많은 관심을 받고 있습니다.
`,
  },

  {
    question: "오산 센트럴시티 운암뜰은 몇 세대 규모인가요?",
    answer: `
오산 센트럴시티 운암뜰은 총 1,606세대 규모의 매머드급 민간임대 아파트입니다.<br/><br/>

단지는 지하 3층부터 지상 최고 29층, 총 15개동 규모로 계획되어 있으며 대단지 프리미엄과 다양한 커뮤니티 시설을 함께 갖춘 브랜드 단지입니다.<br/><br/>

주차공간은 총 2,260대로 세대당 약 1.4대 수준을 확보하여 편리한 주거환경을 제공합니다.
`,
  },

  {
    question: "오산 센트럴시티 운암뜰은 어떤 타입이 있나요?",
    answer: `
오산 센트럴시티 운암뜰은 실수요 선호도가 높은 전용 59㎡와 전용 84㎡ 타입으로 구성됩니다.<br/><br/>

전용 59㎡는 총 1,099세대, 전용 84㎡는 총 507세대로 공급되어 신혼부부부터 가족 단위까지 다양한 수요층이 선택할 수 있는 상품입니다.<br/><br/>

효율적인 공간 활용과 실거주 중심 평면설계가 적용된 것이 특징입니다.
`,
  },

  {
    question: "오산 센트럴시티 운암뜰의 교통환경은 어떤가요?",
    answer: `
오산 센트럴시티 운암뜰은 오산IC와 경부고속도로 접근성이 뛰어나며 오산역과 동탄신도시 생활권 이용이 편리한 교통환경을 갖추고 있습니다.<br/><br/>

GTX-C 연장과 동탄 트램 등 광역교통 개발호재가 거론되고 있어 향후 수도권 접근성 향상도 기대되고 있습니다.<br/><br/>

서울과 동탄, 수원, 평택 등 수도권 남부 주요 지역으로 이동이 편리한 입지입니다.
`,
  },

  {
    question: "오산 센트럴시티 운암뜰의 생활인프라는 어떤가요?",
    answer: `
오산 센트럴시티 운암뜰은 오산시청과 중심상업지역, 롯데마트, 병원 등 다양한 생활편의시설을 가까이 이용할 수 있습니다.<br/><br/>

운암뜰 AI시티 개발과 함께 상업시설과 도시 인프라 확충도 기대되고 있어 생활 편의성이 더욱 높아질 전망입니다.<br/><br/>

쾌적한 주거환경과 풍부한 생활 인프라를 함께 누릴 수 있는 입지입니다.
`,
  },

  {
    question: "오산 센트럴시티 운암뜰의 교육환경은 어떤가요?",
    answer: `
오산 센트럴시티 운암뜰은 단지 인근 초·중·고등학교와 교육시설을 이용할 수 있는 생활권을 갖추고 있습니다.<br/><br/>

다온초등학교, 원당초등학교, 고현초등학교와 성호중학교, 성호고등학교 등이 가까워 자녀 교육환경을 중요하게 생각하는 실수요자들의 관심을 받고 있습니다.<br/><br/>

도보 통학과 생활권 교육 인프라를 함께 기대할 수 있는 입지입니다.
`,
  },

  {
    question: "오산 센트럴시티 운암뜰 모델하우스는 어떻게 방문하나요?",
    answer: `
오산 센트럴시티 운암뜰 모델하우스는 홈페이지 또는 대표번호 상담을 통해 사전 방문예약 후 관람하는 것을 권장합니다.<br/><br/>

방문 시 타입별 평면, 임대조건, 계약조건, 공급일정, 잔여세대 현황 등 다양한 상담을 받아볼 수 있습니다.<br/><br/>

원활한 상담을 위해 사전 예약 후 방문하는 것이 좋습니다.
`,
  },

  {
    question: "오산 센트럴시티 운암뜰은 어떤 분들에게 추천되나요?",
    answer: `
오산 센트럴시티 운암뜰은 오산 신축 대단지와 장기 민간임대 아파트를 찾는 실수요자에게 추천되는 브랜드 단지입니다.<br/><br/>

총 1,606세대 규모의 대단지와 전용 59㎡·84㎡ 중심 구성, 운암뜰 AI시티 개발호재와 우수한 교통환경을 함께 갖춘 것이 장점입니다.<br/><br/>

오산과 동탄 생활권을 함께 이용하면서 미래가치와 안정적인 거주환경을 고려하는 수요자라면 관심 있게 살펴볼 만한 단지입니다.
`,
  },
];

export default faqData;